import React, { useState, useEffect, ChangeEvent, FormEvent } from "react";
import axios from "axios";

export interface Content {
  image: string;
  title: string;
  paragraph: string;
  text: string;
  button: string;
}

const HomeClaim: React.FC = () => {
  const [content, setContent] = useState<Content | null>(null);
  const [formValues, setFormValues] = useState<Content>({
    image: "",
    title: "",
    paragraph: "",
    text: "",
    button: "",
  });
  const [isEditing, setIsEditing] = useState(false);

  useEffect(() => {
    axios
      .get("http://localhost:8000/api/content")
      .then((response) => {
        setContent(response.data);
        setFormValues(response.data); // preload form with fetched data
      })
      .catch((error) => console.error("Error fetching content:", error));
  }, []);

  const handleChange = (
    e: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    const { name, value } = e.target;
    setFormValues((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleSubmit = (e: FormEvent) => {
    e.preventDefault();

    // You can use PUT if your backend supports updating the only resource
    axios
      .put("http://localhost:8000/api/content", formValues)
      .then((response) => {
        setContent(response.data);
        setIsEditing(false);
      })
      .catch((error) => console.error("Error updating content:", error));
  };

  return (
    <div className="cms-container" style={{ paddingTop: "100px" }}>
      <h1>Manage Home Claim Section</h1>

      <form onSubmit={handleSubmit}>
        <label>
          Image URL:
          <input
            type="text"
            name="image"
            value={formValues.image}
            onChange={handleChange}
            required
          />
        </label>
        <label>
          Title (can include HTML):
          <textarea
            name="title"
            value={formValues.title}
            onChange={handleChange}
            required
          />
        </label>
        <label>
          Paragraph:
          <textarea
            name="paragraph"
            value={formValues.paragraph}
            onChange={handleChange}
            required
          />
        </label>
        <label>
          Text (can include HTML):
          <textarea
            name="text"
            value={formValues.text}
            onChange={handleChange}
            required
          />
        </label>
        <label>
          Button Text:
          <input
            type="text"
            name="button"
            value={formValues.button}
            onChange={handleChange}
            required
          />
        </label>

        <button type="submit">{isEditing ? "Update" : "Save"} Content</button>
      </form>

      {content && (
        <div
          style={{
            marginTop: "30px",
            borderTop: "1px solid #ccc",
            paddingTop: "20px",
          }}
        >
          <h2>Preview</h2>
          <img src={content.image} alt="Content" style={{ width: "200px" }} />
          <h3 dangerouslySetInnerHTML={{ __html: content.title }} />
          <p>{content.paragraph}</p>
          <p dangerouslySetInnerHTML={{ __html: content.text }} />
          <button>{content.button}</button>
        </div>
      )}
    </div>
  );
};

export default HomeClaim;
